import axios from 'axios';
import { useQueryClient, useQuery } from '@tanstack/react-query';
import { fetchDefault, fetchFormAuth, fetchForm, setError } from 'src/fetch/common';

import { homeTaxInitData, homeTaxData } from 'src/static/sample/stepC';
import { familyInfoDataFn } from 'src/fetch/stepA';
import { dataSet, dataStaticSet } from './dataSet';
import { creditcardInfoDataFn } from './card';
import { insurfeeInfoDataFn } from './insurfee';
import { medicalInfoDataFn } from './medical';
import { educationInfoDataFn } from './education';
import { donationInfoDataFn } from './donation';
import { houseLoanInfoDataFn } from './houseLoan';
import { houseRentFInfoDataFn } from './houseRentF';
import { houseRentMInfoDataFn } from './houseRentM';
import { houseRentPInfoDataFn } from './houseRentP';
import { houseSaveInfoDataFn } from './houseSaving';
import { pensionInfoDataFn } from './pension';
import { othincomeInfoDataFn } from './othincome';
import { settlementInfoDataFn } from './settlement';
import _ from 'lodash';
import { error } from 'console';

const stateTimeStr = process.env.REACT_APP_REACTQUERY_STALETIME || '0';
const STALETIME = Number(stateTimeStr);

/**
 * Fetch: StepC
 */
export const fetchPdfFileData = async (
  param: any,
  errorModalState: any,
  infoStore: any,
  creditcardDataState: any,
  loadingState: any,
  queryClient: any,
  callback: any
) => {
  try {
    loadingState({ active: '_active' });
    // total info fetch
    const resData = await pdfFileUpload(errorModalState, param, infoStore, queryClient);
    console.log('[FETCH_PDF_FILE_DATA]:', resData);
    // set data
    callback(resData);

    loadingState({ active: '' });
  } catch (e) {
    console.log('error:', e);
  }
};

export const fetchPdfFileReset = async (
  param: any,
  errorModalState: any,
  infoStore: any,
  loadingState: any,
  queryClient: any,
  callback: any
) => {
  try {
    loadingState({ active: '_active' });

    const infoData: any = homeTaxInitData;
    const { resError, resData } = dataStaticSet(infoData, null);
    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      infoStore({ data: resData });
    }
    loadingState({ active: '' });
    callback({});
  } catch (e) {
    console.log('error:', e);
  }
};

function delay(ms: any) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const pdfFileUpload = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  try {
    const paramSet = param;
    const fetchUrl = '/api/nts-pdf/upload';
    const fetchKey = 'NTS-PDF_INSERT';
    console.log('[PDF_FILE_UPLOAD] param:', paramSet);
    const fileData = paramSet.attachFile[0].attachFile;
    // console.log('[fileData] :', fileData);

    // return false;
    const formData = new FormData();
    for (const item of fileData) {
      formData.append('file', item);
    }
    // formData.append('file', fileData);
    formData.append('acct_year', paramSet.acct_year);
    formData.append('co_cd', paramSet.co_cd);
    formData.append('co_id', paramSet.co_id);

    // for (const pair of formData.entries()) {
    //   console.log(pair[0] + ', ' + pair[1]);
    // }

    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey, paramSet],
      queryFn: () => fetchForm(formData, fetchUrl),
    });
    const retData = data?.data || {};

    if (retData.status?.code + '' === '200') {
      // errorModalState({
      //   data: {
      //     type: 'error',
      //     icon: 'ri-alert-line',
      //     mainTitle: retData.status?.message,
      //     subTitle: '',
      //     code: '200',
      //   },
      //   active: '_active',
      // });
      // errorModalState({
      //   data: { message: retData.status?.message || '파일 업로드 성공', detail: 'XXXX' },
      //   active: '_active',
      // });
    }

    return retData;

    // if (retData.applied !== 'Y') {
    //   const errorSet = setError(data.data, null);
    //   errorModalState({
    //     data: {
    //       type: 'error',
    //       icon: 'ri-alert-line',
    //       mainTitle: 'ErrorXXXX',
    //       subTitle: '',
    //       code: '500',
    //     },
    //     active: '_active',
    //   });
    // }
  } catch (err: any) {
    console.error(err);
    errorModalState({
      data: { message: '파일 업로드 실패', detail: err.message },
      active: '_active',
    });
  }
};

// const pdfFileUpload = async (
//   errorModalState: any,
//   param: any,
//   initDataStore: any,
//   queryClient: any
// ) => {
//   try {
//     const paramSet = param;
//     const fetchUrl = '/api/nts-pdf/upload';
//     const fetchKey = 'NTS-PDF_INSERT';
//     console.log('[PDF_FILE_UPLOAD] param:', paramSet);
//     const fileData = paramSet.attachFile[0].attachFile;
//     const formData = new FormData();
//     formData.append('file', fileData);
//     formData.append('acct_year', paramSet.acct_year);
//     formData.append('co_cd', paramSet.co_cd);
//     formData.append('co_id', paramSet.co_id);

//     for (const pair of formData.entries()) {
//       console.log(pair[0] + ', ' + pair[1]);
//     }

//     // formData.append('apply', paramData.apply);
//     // formData.append('skip_invalid', paramData.skip_invalid);
//     // formData.append('template_type', paramData.template_type);
//     // formData.append('file', paramData.file.attachFile);

//     const data = await queryClient.fetchQuery({
//       queryKey: [fetchKey, paramSet],
//       queryFn: () => fetchForm(formData, fetchUrl),
//     });
//     const retData = data?.data || {};

//     if (retData.status?.code + '' === '200') {
//       // errorModalState({
//       //   data: {
//       //     type: 'error',
//       //     icon: 'ri-alert-line',
//       //     mainTitle: retData.status?.message,
//       //     subTitle: '',
//       //     code: '200',
//       //   },
//       //   active: '_active',
//       // });
//       // errorModalState({
//       //   data: { message: retData.status?.message || '파일 업로드 성공', detail: 'XXXX' },
//       //   active: '_active',
//       // });
//     }

//     return retData;

//     // if (retData.applied !== 'Y') {
//     //   const errorSet = setError(data.data, null);
//     //   errorModalState({
//     //     data: {
//     //       type: 'error',
//     //       icon: 'ri-alert-line',
//     //       mainTitle: 'ErrorXXXX',
//     //       subTitle: '',
//     //       code: '500',
//     //     },
//     //     active: '_active',
//     //   });
//     // }
//   } catch (err: any) {
//     console.error(err);
//     errorModalState({
//       data: { message: '파일 업로드 실패', detail: err.message },
//       active: '_active',
//     });
//   }
// };
const pdfFileStaticUpload = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  try {
    await delay(2000);
    const infoData: any = homeTaxData;
    const { resError, resData } = dataStaticSet(infoData, null);
    console.log('[PDF_FILE_UPLOAD]:', param, resData);

    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
    }

    return resData;
  } catch (e) {
    console.log('error:', e);
  }
};

/**
 * Fetch: StepC
 */
export const fetchData = async (
  param: any,
  errorModalState: any,
  familyInfoDataState: any,
  creditcardDataState: any,
  insurfeeDataState: any,
  medicalDataState: any,
  educationDataState: any,
  donationDataState: any,
  loanDataState: any,
  rentFDataState: any,
  rentMDataState: any,
  rentPDataState: any,
  savingDataState: any,
  pensionDataState: any,
  othincomeDataState: any,
  settlementInfoState: any,
  loadingState: any,
  queryClient: any
) => {
  try {
    loadingState({ active: '_active' });
    const familyData = await familyInfoDataFn(
      errorModalState,
      param,
      familyInfoDataState,
      queryClient
    );
    // 신용카드등
    await creditcardInfoDataFn(
      errorModalState,
      param,
      creditcardDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 보험료
    await insurfeeInfoDataFn(
      errorModalState,
      param,
      insurfeeDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 의료비
    await medicalInfoDataFn(
      errorModalState,
      param,
      medicalDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 교육비
    await educationInfoDataFn(
      errorModalState,
      param,
      educationDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 기부금
    await donationInfoDataFn(
      errorModalState,
      param,
      donationDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 주택자금:장기주택저당차입금
    await houseLoanInfoDataFn(
      errorModalState,
      param,
      loanDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 주택자금:전세
    await houseRentFInfoDataFn(
      errorModalState,
      param,
      rentFDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 주택자금:월세
    await houseRentMInfoDataFn(
      errorModalState,
      param,
      rentMDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 주택자금:사인간차입(금전소비대차,임대차)
    await houseRentPInfoDataFn(
      errorModalState,
      param,
      rentPDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 주택자금:주택자금저축
    await houseSaveInfoDataFn(
      errorModalState,
      param,
      savingDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 연금계좌
    await pensionInfoDataFn(
      errorModalState,
      param,
      pensionDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 기타
    await othincomeInfoDataFn(
      errorModalState,
      param,
      othincomeDataState,
      queryClient,
      familyInfoDataFn,
      familyData
    );
    // 정산결과
    await settlementInfoDataFn(errorModalState, param, settlementInfoState, queryClient);

    loadingState({ active: '' });
  } catch (e) {
    console.log('error:', e);
  }
};
